<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
            <el-breadcrumb-item>
                    <i class="el-icon-lx-cascades"></i> {{$t('pages.userManage.breadcrumb')}}
                </el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <el-container style="border: 1px solid #eee">
            <el-aside :style="{ width: '200px', 'background-color': '#fff', height: leftHeight }">
                <div :style="{ height: leftTreeHeight, 'overflow-y': 'auto' }">
                    <el-tree class="filter-tree" :data="deptTree" :props="defaultProps" :expand-on-click-node="false" node-key="id" default-expand-all ref="tree" style="height: 50px" @node-click="handleNodeClick" highlight-current></el-tree>
                </div>
            </el-aside>
            <el-main>
                <div>
                    <div class="handle-headleft">
                        <el-button type="primary" icon="el-icon-circle-plus-outline" @click="handleAdd">{{$t('pages.userManage.add')}}</el-button>
                        <el-button type="danger" icon="el-icon-delete" @click="delAllSelection">{{$t('pages.userManage.delete')}}</el-button>
                    </div>
                    <div class="handle-headright">
                        <el-input v-model="query.Field1" @blur="getData()" class="handle-select mr10" :placeholder="$t('pages.userManage.phonePh')"></el-input>
                        <el-input v-model="query.Field2" @blur="getData()" class="handle-select mr10" :placeholder="$t('pages.userManage.accountPh')"></el-input>
                        <el-button type="primary" icon="el-icon-search" @click="getData">{{$t('pages.userManage.search')}}</el-button>
                    </div>
                </div>
                <el-table :data="users" border class="table" ref="multipleTable" :element-loading-text="$t('pages.userManage.loading')" v-loading="loading" header-cell-class-name="table-header" @selection-change="handleSelectionChange" @row-dblclick="dbSelected">
                    <el-table-column type="selection" width="55" align="center"></el-table-column>
                    <el-table-column type="index" width="50" :label="$t('pages.userManage.index')"></el-table-column>
                    <el-table-column prop="LoginId" :label="$t('pages.userManage.loginId')"></el-table-column>
                    <el-table-column sortable prop="RealName" :label="$t('pages.userManage.realName')"></el-table-column>
                    <el-table-column prop="Phone" :label="$t('pages.userManage.phone')"></el-table-column>
                    <el-table-column prop="UserType" :label="$t('pages.userManage.userType')">
                        <template slot-scope="scope">{{ scope.row.UserType | usertypeFormat }}</template>
                    </el-table-column>
                    <el-table-column prop="deptName" :label="$t('pages.userManage.dept')"></el-table-column>
                    <el-table-column prop="ModifyUserId" :label="$t('pages.userManage.operator')"></el-table-column>
                    <el-table-column sortable prop="ModifyDate" :label="$t('pages.userManage.operateTime')">
                        <template slot-scope="scope">{{ scope.row.ModifyDate | formateData }}</template>
                    </el-table-column>
                    <el-table-column :label="$t('pages.userManage.actions.edit')" width="110" align="center">
                        <template slot-scope="scope">
                            <!-- <el-button type="text" icon="el-icon-tickets" @click="handleShow(scope.row.Id, scope.row)">查看 </el-button> -->
                            <el-button type="text" icon="el-icon-edit" @click="handleEdit(scope.row.Id, scope.row)">{{$t('pages.userManage.actions.edit')}}</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="pagination">
                    <el-pagination background layout="total, prev, pager, next" :current-page="query.PageIndex" :page-size="query.PageSize" :total="pageCount" @current-change="handlePageChange"></el-pagination>
                </div>
            </el-main>
        </el-container>

        <!-- 编辑弹出框 -->
        <el-dialog :title="headTitle" :visible.sync="editVisible" width="50%" class="abow_dialog" :close-on-click-modal="false">
            <el-form ref="user" :model="user" :rules="rules" label-width="90px">
                <el-row>
                    <el-col :span="12">
                        <el-form-item :label="$t('pages.userManage.fields.account')" prop="LoginId">
                            <el-input v-model="user.LoginId" :disabled="!isadd"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item :label="$t('pages.userManage.fields.name')" prop="RealName">
                            <el-input v-model="user.RealName"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item :label="$t('pages.userManage.fields.password')" prop="Password">
                            <el-input v-model="user.Password" show-password></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12" v-if="isadd">
                        <el-form-item :label="$t('pages.userManage.fields.confirmPassword')" prop="agapwd">
                            <el-input v-model="user.agapwd" show-password></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item :label="$t('pages.userManage.fields.phone')" prop="Phone">
                            <el-input v-model="user.Phone"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item :label="$t('pages.userManage.fields.userRole')" prop="UserType">
                            <!-- <el-select v-model="user.UserType" class="size-full">
                                <el-option key="1" label="管理员" value="1"></el-option>
                                <el-option key="2" label="用户" value="2"></el-option>
                            </el-select>-->
                            <el-select v-model="user.UserType" class="size-full" :disabled="UpdateRoleAndDept">
                                <el-option v-for="item in roles" :key="item.id" :label="item.name" :value="item.id"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item :label="$t('pages.userManage.fields.dept')">
                            <el-cascader :key="isResouceShow" v-model="user.DeptIdTree" :options="deptTree" :props="{ checkStrictly: true }" class="size-full" clearable :disabled="UpdateRoleAndDept"></el-cascader>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col>
                        <el-form-item :label="$t('pages.userManage.fields.remark')" prop="Remark">
                            <quill-editor ref="myTextEditor" v-model="user.Remark" :options="editorOption"></quill-editor>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="editVisible = false">{{$t('pages.userManage.dialog.cancel')}}</el-button>
                <el-button type="primary" @click="saveEdit('user')">{{$t('pages.userManage.dialog.confirm')}}</el-button>
            </span>
        </el-dialog>

        <!-- 查看弹出框 -->
        <el-dialog :title="$t('pages.userManage.dialog.viewTitle')" :visible.sync="viewVisible" width="50%" :close-on-click-modal="false">
            <el-form ref="user" :model="user" :rules="rules" label-width="90px">
                <el-row>
                    <el-col :span="12">
                        <el-form-item :label="$t('pages.userManage.fields.account')">
                            <span v-text="user.LoginId"></span>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item :label="$t('pages.userManage.fields.name')">
                            <span v-text="user.RealName"></span>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item :label="$t('pages.userManage.fields.password')">
                            <span v-text="user.Password"></span>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item :label="$t('pages.userManage.fields.phone')">
                            <span v-text="user.Phone"></span>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item :label="$t('pages.userManage.userType')">{{ user.UserType == '1' ? '管理员' : '用户' }}</el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item :label="$t('pages.userManage.fields.dept')">
                            <span v-html="user.deptName"></span>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item :label="$t('pages.userManage.operateTime')">{{ user.ModifyDate | formateData }}</el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item :label="$t('pages.userManage.fields.remark')">
                            <span v-html="user.Remark"></span>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="viewVisible = false">{{$t('pages.userManage.dialog.close')}}</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';
import { SortField, toTree, getchild } from '../../utils/helper';
import { quillEditor } from 'vue-quill-editor';
import { RefreshToken } from '../../api/Auth';
let that;
let roleArr = [];
export default {
    name: 'user',
    data: function () {
        const checkPass = (rule, value, callback) => {
            if (value !== this.user.Password) {
                callback(new Error(this.$t('pages.userManage.rules.mismatch')));
            } else {
                callback();
            }
        };
        return {
            UpdateRoleAndDept: false,
            deptArr: [],
            deptTree: [],
            headTitle: '',
            viewVisible: false,
            isadd: false,
            user: {},
            editVisible: false,
            users: [],
            pageCount: 1,
            multipleSelection: [],
            delList: [],
            loading: false,
            roles: [],
            isResouceShow: 0,
            query: {
                Field1: '',
                Field2: '',
                Field3: '',
                PageIndex: 1,
                PageSize: 15
            },
            editorOption: {
                placeholder: this.$t('pages.userManage.rules.usernameRequired')
            },
            leftHeight: '',
            leftTreeHeight: '',
            defaultProps: {
                children: 'children',
                label: 'label'
            },
            rules: {
                LoginId: [
                    {
                        required: true,
                        message: this.$t('pages.userManage.rules.usernameRequired'),
                        trigger: 'blur'
                    },
                    {
                        min: 2,
                        max: 15,
                        message: this.$t('pages.userManage.rules.lengthRange'),
                        trigger: 'blur'
                    }
                ],
                RealName: [
                    {
                        required: true,
                        message: this.$t('pages.userManage.rules.nameRequired'),
                        trigger: 'blur'
                    }
                ],
                Password: [
                    {
                        required: true,
                        message: this.$t('pages.userManage.rules.pwdSet'),
                        trigger: 'blur'
                    },
                    {
                        min: 5,
                        message: this.$t('pages.userManage.rules.pwdMin'),
                        trigger: 'blur'
                    }
                ],
                agapwd: [
                    {
                        required: true,
                        message: this.$t('pages.userManage.rules.confirmRequired'),
                        trigger: 'blur'
                    },
                    {
                        min: 5,
                        message: this.$t('pages.userManage.rules.pwdMin'),
                        trigger: 'blur'
                    },
                    {
                        validator: checkPass,
                        message: this.$t('pages.userManage.rules.mismatch'),
                        trigger: 'blur'
                    }
                ],
                UserType: [
                    {
                        required: true,
                        message: this.$t('pages.userManage.rules.roleTypeRequired'),
                        trigger: 'blur'
                    }
                ],
                Phone: [
                    {
                        required: true,
                        message: this.$t('pages.userManage.rules.phoneRequired'),
                        trigger: 'blur'
                    }
                ]
            }
        };
    },
    filters: {
        usertypeFormat(UserType) {
            var usertypeName = '';
            var item = roleArr.filter((t) => t.id == UserType);
            usertypeName = item.length > 0 ? item[0]['name'] : '';
            return usertypeName;
        }
    },
    components: {
        quillEditor
    },
    created() {
        this.getDept();
        this.getRoles();
    },
    beforeCreate() {
        that = this;
    },
    mounted: function () {
        this.setCJHeight();
    },
    methods: {
        onEditorChange({ editor, html, text }) {
            this.content = html;
        },
        setCJHeight() {
            this.$nextTick(() => {
                // 页面渲染完成后的回调
                var headerHeight = document.getElementsByClassName('content')[0].offsetHeight;
                this.leftHeight = headerHeight * 0.93 + 'px';
                this.leftTreeHeight = headerHeight * 0.85 + 'px';
            });
        },
        handleNodeClick(data, node, self) {
            var newdata = getchild(this.deptArr, [data.id], data.id);
            this.query.Field3 = newdata.join(',');
            this.getData();
        },
        saveEdit() {
            this.$refs['user'].validate((valid) => {
                if (valid) {
                    var parentidPath = this.user.DeptIdTree;
                    this.user.DeptId = parentidPath[parentidPath.length - 1] + '';
                    this.isResouceShow = this.isResouceShow + 1;
                    if (this.isadd) {
                        this.$zybhttp
                            .post('Account/UserAdd', this.user)
                            .then((res) => {
                                if (res.data.status == 0) {
                                    this.$notify.success(this.$t('pages.userManage.notify.addSuccess'));
                                    this.getData();
                                    this.editVisible = false;
                                    this.user = {};
                                } else {
                                    this.$notify.error(this.$t('pages.userManage.notify.addFail'));
                                }
                            })
                            .catch((err) => this.$notify.error(this.$t('pages.userManage.notify.networkAddError')));
                    } else {
                        this.$zybhttp
                            .post('Account/UserUpdate', this.user)
                            .then((res) => {
                                if (res.data.status == 0) {
                                    this.$notify.success(this.$t('pages.userManage.notify.updateSuccess'));
                                    this.getData();
                                    this.editVisible = false;
                                } else {
                                    this.$notify.error(this.$t('pages.userManage.notify.updateFail'));
                                }
                            })
                            .catch((err) => this.$notify.error(this.$t('pages.userManage.notify.networkUpdateError')));
                    }
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        async updateToken() {
            const resRefresh = await RefreshToken();
            if (resRefresh.status === 0) {
                localStorage.setItem('token', resRefresh.msg);
            }
        },
        async getData() {
            // this.loading=true;
            this.$zybhttp
                .post('Account/GetList', this.query)
                .then((res) => {
                    if (res.data.status == 0) {
                        res = res.data;
                        var d = res.data.list;
                        var newdata = d.sort(SortField('Id', 'desc'));
                        this.users = newdata;
                        this.pageCount = res.data.total || 0;
                    } else {
                        this.$notify.error(res.message);
                    }
                })
                .catch((err) => this.$notify.error(this.$t('pages.userManage.notify.networkListError')));
        },
        getRoles() {
            // this.loading=true;
            let userInfo = JSON.parse(localStorage.getItem('ms_userInfo'));
            this.$zybhttp
                .post('role/GetList', { Field3: userInfo.id + '' })
                .then((res) => {
                    if (res.data.status == 0) {
                        res = res.data;
                        var d = res.data.list;
                        var newdata = d.sort(SortField('Id', 'desc'));
                        newdata = newdata.map((x) => {
                            x.id = x.id + '';
                            return x;
                        }, []);
                        this.roles = newdata;
                        roleArr = newdata;
                        var userDept = parseInt(userInfo.deptId);
                        var newdata = getchild(this.deptArr, [userDept], userDept);
                        this.query.Field3 = newdata.join(',');

                        this.getData();
                    } else {
                        this.$notify.error(res.message);
                    }
                })
                .catch((err) => this.$notify.error(this.$t('pages.userManage.notify.networkListError')));
        },
        getAxiso() {
            this.$zybhttp
                .get('Account/UserDel?ids=1')
                .then((res) => {})
                .catch((err) => console.log(err, this.$t('pages.userManage.notify.networkListError')));
        },
        getDept() {
            var serach = {};
            this.$zybhttp
                .post('Dept/GetList', { Field3: '1' })
                .then((res) => {
                    if (res.data.status == 0) {
                        this.deptArr = res.data.data.list;
                        var d = res.data.data.list;
                        var userDept = parseInt(JSON.parse(window.localStorage.getItem('ms_userInfo')).deptId);
                        var newdata = getchild(d, [userDept], userDept);
                        d = d.filter((x) => newdata.indexOf(x.id) > -1);
                        d = d.sort(SortField('sort', 'asc'));
                        var arr = [];
                        for (var i = 0; i < d.length; i++) {
                            arr.push({ id: d[i].id, pid: d[i].parentId, value: d[i].id, label: d[i].name });
                        }
                        this.deptTree = toTree(arr);
                    } else {
                        this.$notify.error(res.message);
                    }
                })
                .catch((err) => this.$notify.error(this.$t('pages.userManage.notify.networkListError')));
        },
        handleEdit(id, row) {
            this.user = row;
            let userInfo = JSON.parse(localStorage.getItem('ms_userInfo'));
            if (userInfo.userType == row.UserType) {
                this.viewVisible = true;
                return;
            }
            this.user.id = row.id;
            this.editVisible = true;
            this.isadd = false;
            var arr = new Array();

            if (this.user.DeptId != '0') {
                var d = this.user.parentIdPath.split(',');
                var char = userInfo.deptId;
                if (d.indexOf(char) > -1) {
                    var a = d.slice(d.indexOf(char), d.length);
                    for (var i = 0; i < a.length; i++) {
                        arr.push(parseInt(a[i]));
                    }
                }
            }
            arr.push(parseInt(this.user.DeptId));
            this.user.DeptIdTree = arr;
            this.headTitle = this.$t('pages.userManage.dialog.editTitleUpdate');
            this.UpdateRoleAndDept = userInfo.loginId == row.LoginId;
        },
        dbSelected(row) {
            this.user = row;
            let userInfo = JSON.parse(localStorage.getItem('ms_userInfo'));
            if (userInfo.userType == row.UserType) {
                this.viewVisible = true;
                return;
            }
            this.user.id = row.id;
            this.editVisible = true;
            this.isadd = false;
            var arr = new Array();

            if (this.user.DeptId != '0') {
                var d = this.user.parentIdPath.split(',');
                var char = userInfo.deptId;
                if (d.indexOf(char) > -1) {
                    var a = d.slice(d.indexOf(char), d.length);
                    for (var i = 0; i < a.length; i++) {
                        arr.push(parseInt(a[i]));
                    }
                }
            }
            arr.push(parseInt(this.user.DeptId));
            this.user.DeptIdTree = arr;
            this.headTitle = this.$t('pages.userManage.dialog.editTitleUpdate');
            this.UpdateRoleAndDept = userInfo.loginId == row.LoginId;
        },
        handleShow(index, row) {
            this.user = row;
            this.viewVisible = true;
        },
        handleAdd() {
            var ms_userInfo = localStorage.getItem('ms_userInfo');
            var userinfo = JSON.parse(ms_userInfo);
            this.user = {};
            this.isadd = true;
            let date = new Date();
            // this.user.CreateDate = dateFormat.formatDate(date, 'yyyy-MM-dd hh:mm:ss');
            this.user.CreateUserId = userinfo.loginId;
            this.user.ModifyUserId = userinfo.loginId;
            this.editVisible = true;
            this.headTitle = this.$t('pages.userManage.dialog.editTitleAdd');
        },
        handlePageChange(val) {
            this.$set(this.query, 'PageIndex', val);
            this.getData();
        },
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        delAllSelection() {
            const length = this.multipleSelection.length;
            let str = '';
            let strValue = '';
            this.delList = this.delList.concat(this.multipleSelection);
            for (let i = 0; i < length; i++) {
                str += this.multipleSelection[i].RealName + ' ';
                strValue += this.multipleSelection[i].Id + ',';
            }
            if (strValue.length == 0) {
                this.$notify.warning(this.$t('pages.userManage.notify.deleteSelectedWarning'));
                return;
            }
            this.$confirm(this.$t('pages.userManage.notify.deleteConfirm'), this.$t('pages.userManage.notify.deleteConfirmTitle'), {
                type: 'warning'
            })
                .then(() => {
                    this.$zybhttp
                        //.get('Account/UserDel?ids=1')
                        .get('Account/UserDel', {
                            params: { ids: strValue }
                        })
                        .then((res) => {
                            if (res.data.status == 0) {
                                this.$notify.success(this.$t('pages.userManage.notify.deleteSuccess', { names: str }));
                                this.getData();
                            } else {
                                this.$notify.error(this.$t('pages.userManage.notify.deleteFail'));
                            }
                        })
                        .catch((err) => this.$notify.error(this.$t('pages.userManage.notify.networkDeleteError')));
                    this.multipleSelection = [];
                })
                .catch(() => {});
        },
        indexMethod(index) {
            return index + 1;
        }
    }
};
</script>

<style scoped>
.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 200px;
}

.handle-headleft {
    float: left;
    margin-bottom: 15px;
}
.handle-headright {
    float: right;
    margin-bottom: 15px;
}

.handle-input {
    width: 300px;
    display: inline-block;
}

.table {
    width: 100%;
    font-size: 14px;
}

.red {
    color: #ff0000;
}

.mr10 {
    margin-right: 10px;
}

.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}

.size-full {
    width: 100%;
}

.el-button--small,
.el-button--small.is-round {
    padding: 9px 8px;
}

.el-main {
    color: #333;
    text-align: center;
    padding: 0px 0px 0px 15px;
}
</style>


<style>
.el-dialog__body {
    height: 55vh;
    overflow: hidden;
}
.el-tree-node.is-current > .el-tree-node__content {
    background-color: #dfe0e0 !important;
}
/* 富文本框高度设置 */
.ql-container {
    min-height: 200px;
    height: 200px;
}
</style>
